export enum Animation {
  /** The standard duration for the corgi-x animations (ms). */
  StandardDuration = 300,
}
